
import { Component, Vue } from 'vue-property-decorator';
import AppHeaderComponent from '@/components/AppHeaderComponent.vue';
import AppFooterComponent from '@/components/AppFooterComponent.vue';
import DebugHeaderComponent from '@/components/DebugHeaderComponent.vue';
import LoadingOverlayComponent from '@/components/LoadingOverlayComponent.vue';
import store from '@/store';
import { CMSApi, JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponse } from '@/openapi/order';
import OrderApiConfig from '@/api/OrderApiConfig';
import ApiService from '@/services/ApiService';

@Component({
  components: {
    AppHeaderComponent,
    AppFooterComponent,
    DebugHeaderComponent, // TODO, 削除予定
    LoadingOverlayComponent,
  },
})
export default class App extends Vue {
  test = window.location.hostname === 'benefitstation_dp.isol-tool.com';

  local = document.location.href.includes('localhost');

  resHeaderFooter: JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponse = {
    fieldHeader: {
      value: '',
    },
    fieldFooter: {
      value: '',
    },
    fieldImage: [],
  };

  get showLoading(): boolean {
    return store.state.isLoading;
  }

  created(): void {
    if (this.local || window.location.pathname === '/v1/fellowtravelers/CompanionOrder') return;

    const config = OrderApiConfig.newInstance();
    const apiCms = new CMSApi(config);

    apiCms
      .getHeaderFooter()
      .then((res: JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponse) => {
        this.resHeaderFooter = res;
      })
      .catch((error: unknown) => {
        if (ApiService.isErrorData(error)) {
          // do nothing.
        } else if (this.$route.name !== 'Erro01' && this.$route.name !== 'Erro02' && this.$route.name !== 'Erro03') {
          this.$router.push({
            name: 'Erro01',
          });
        }
      })
      .finally(() => {
        // do nothing.
      });
  }
}
